import React from 'react';
import { Button, Col } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { ModelUnitDetail } from '../models/investors';
import useModalState from '../../../hooks/useModalState';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import useAuth from '../../../hooks/useAuth';
import { migrateModelUnitToUnitPcvEndpoint } from '../services/investorService';
import BasicModal from '../../../components/modals/BasicModal';

interface Props {
  modelUnit: ModelUnitDetail;
}

const MigrateUnitToPcvButton: React.FC<Props> = ({ modelUnit }) => {
  const navigate = useNavigate();
  const [isModalOpen, toggleModal] = useModalState();
  const { callEndpoint } = useCallApiAndLoad();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const handleMigrate = async () => {
    const { status } = await callEndpoint(
      migrateModelUnitToUnitPcvEndpoint(
        modelUnit.project_id,
        modelUnit.id,
        token,
      ),
    );
    if (status === 201) {
      navigate(`/projects/${modelUnit.project_id}/pcvs/list`);
    }
  };

  return (
    <Col lg="12" className="pb-2">
      <Button block color="warning" size="sm" onClick={toggleModal}>
        <i className="fa fa-sync" /> Migrar unidad a pcv
      </Button>
      <BasicModal
        isOpen={isModalOpen}
        onToggle={toggleModal}
        titleText="Migrar unidad a PCV"
        bodyText={`¿Deseas convertir esta unidad ${modelUnit.name} a una unidad de pcv?`}
        confirmationText="Confirmar"
        abortText="Cancelar"
        onConfirmation={handleMigrate}
      />
    </Col>
  );
};

export default MigrateUnitToPcvButton;
